import { Component, OnInit, Optional, Inject, Output, EventEmitter, Input, OnDestroy } from '@angular/core';
import { IAppDataStore } from '@pershing/pershing-core';
import { Params } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ExchangeAgreementDialogComponent } from '../exchange-agreement-dialog.component';
import { TradingEntitlements, TradingService } from '@pershing/trading-common';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';

@Component({
    selector: 'exchange-agreement-nav',
    templateUrl: './exchange-agreement-nav.component.html'
})

export class ExchangeAgreementNavComponent implements OnInit, OnDestroy {

    @Input() platform: string;

    public tradingEntitlements: TradingEntitlements = null;
    public errorInFetchingRolesAndEntitlements: boolean = false;


    frompage: any;
    showExchangeAgreement: boolean = false;
    queryParam: Params;
    isAdvisor: boolean = false;
    isAda: boolean = false;
    entitlementsSub: Subscription;
    dialogSub: Subscription;
    @Output() update = new EventEmitter();
    constructor(
        private tradingService: TradingService,
        private dialog: MatDialog,
        private appStore: IAppDataStore,
        @Optional() @Inject('AppSettings') appSettings: any) {
        this.isAdvisor = appSettings.isAdvisor;
        this.isAda = appSettings.themeType === 'ada';
    }
    ngOnInit() {
        this.dialogSub = this.tradingService.exchangeAgreementDialogState$.subscribe(input => {
            if (input === 'updateEntitlements') {
                this.update.emit();
            }
        });

        this.entitlementsSub = this.tradingService.onEntitlementsSubject$.
        subscribe(
            success => {
                this.entitlementsSuccessCallback(success);
            },
            error => this.entitlementsErrorCallback(error)
        );
        this.tradingService.getEntitlements(this.platform);

    }

    entitlementsSuccessCallback(entitlementsResponse: any): void {

        if (entitlementsResponse === null) {
            return;
        }

        if (entitlementsResponse instanceof HttpErrorResponse) {
            this.entitlementsErrorCallback(entitlementsResponse);
            return;
        }

        if ( entitlementsResponse.errorCode === 0 ) {
            this.tradingEntitlements = entitlementsResponse.response as TradingEntitlements;

            this.errorInFetchingRolesAndEntitlements = false;
            this.tradingService.tradingEntitlements = this.tradingEntitlements;

            this.showExchangeAgreement = (
                this.tradingEntitlements.isRTQuotesEnabled && !this.tradingEntitlements.isExchangeAgreementSignedByUser && this.tradingEntitlements.isRetailUser);
        } else {
            this.errorInFetchingRolesAndEntitlements = true;
        }
    }

    entitlementsErrorCallback(error: any): void {
        this.errorInFetchingRolesAndEntitlements = true;
    }

    redirect(): void {
        this.appStore.put('EXCHANGE_AGREE_LASTPAGE', this.frompage);
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.data = {
            platform : this.platform
        };

        const exchangeAgreementDialogComponent = this.dialog.open(ExchangeAgreementDialogComponent, dialogConfig);

        exchangeAgreementDialogComponent.afterClosed().subscribe(result => {
            console.log(result);
            // fire the entitlement call to refresh the entitlement data in the client memory
            this.tradingService.getEntitlements(this.platform);
        });

    }

    ngOnDestroy(): void {
        if ( this.entitlementsSub ) {
            this.entitlementsSub.unsubscribe();
        }

        if ( this.dialogSub ) {
            this.entitlementsSub.unsubscribe();
        }


    }
}
